<div class="ac-page c7-access-view c7-access-consent">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" [attr.aria-label]="'CULTURA'">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let lang of supportedLanguages" [value]="lang.code">{{ lang.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <p class="ac-status" *ngIf="state === 'loading'" role="status">{{ "uiPack.common.loading" | translate }}</p>

    <section class="ac-card" *ngIf="state === 'ready'" aria-labelledby="ac-consent-title">
      <div class="ac-card__head">
        <h2 id="ac-consent-title">{{ "consentPage.title" | translate }}</h2>
        <p class="ac-card__sub">{{ "consentPage.lead" | translate }}</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate class="ac-form">
        <app-consent-checkboxes [form]="form" [submitted]="submitted" [participant]="needsConsent"
          [showTerms]="needsTerms" [showInfo]="needsConsent" [company]="companyName" [purpose]="purpose" [purposeText]="purposeText"></app-consent-checkboxes>

        <button class="ac-btn" type="submit" [disabled]="isLoading || !consentsGiven">
          {{ (isLoading ? "consentPage.submitting" : "consentPage.submit") | translate }}
        </button>
        <p class="ac-error ac-error--block" *ngIf="serverError" role="alert">{{ serverError }}</p>
      </form>

      <p class="ac-card__alt">
        <a href="javascript:void(0)" (click)="logout()">{{ "consentPage.logout" | translate }}</a>
      </p>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
